module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canis_minor/cmi_ir2-ad307cfad87cebdcbf6b90b9de5f4c97.jpg";